import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import errorTrack from '../../../util/Genesys';
import { MODAL_ID } from '../shared/Constants';
import { setCookie } from '../../hooks/useCookie';

const { publicRuntimeConfig } = getConfig();

const {
  NBI_ORDER_PENDING,
  NBI_ORDER_RESERVED,
  NBI_ACTIVE_LINES,
  NBI_INTERVENTION_AREA,
  NBI_MULTIPLE_PREMISES,
  NBI_SURVEY_REQUIRED,
} = MODAL_ID;
const NBIErrorModal = ({ enableNBIPrevention, NEQDetails }) => {
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const router = useRouter();

  const getCmsData = async () => {
    try {
      let data = {};
      if (NEQDetails?.multiplePremises) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_MULTIPLE_PREMISES,
        });
      } else if (NEQDetails?.pendingInstallation) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_ORDER_PENDING,
        });
      } else if (NEQDetails?.reserved) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_ORDER_RESERVED,
        });
      } else if (!NEQDetails?.interventionArea) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_INTERVENTION_AREA,
        });
      } else if (NEQDetails?.surveyRequired) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_SURVEY_REQUIRED,
        });
      } else if (NEQDetails?.activeLines >= 1) {
        data = await fetchInfo({
          collectionType: 'eir-action-modals',
          modalID: NBI_ACTIVE_LINES,
        });
      }
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOk = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_CONTACT_NUMBER}`);
  };
  useEffect(() => {
    getCmsData();
    setCookie('ION', 'API_FAILED', 'getNEQResult');
    // clearLocalStorage();
    // clearAllCookies();
  }, []);
  const handleChatNow = modalId => {
    errorTrack(modalId);
  };
  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={enableNBIPrevention.value}
      handleClose={enableNBIPrevention.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
    ${
      cmsCollectionData?.attributes?.secondHalfDescription
        ? cmsCollectionData?.attributes?.secondHalfDescription
        : ''
    }
    `}
      cta={[
        {
          // text: 'Chat now',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Chat now',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleChatNow(cmsCollectionData?.attributes?.modalID),
        },
        {
          // text: 'Call 1800 303 641',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Call 1800 303 641',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => handleOk(enableNBIPrevention),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default NBIErrorModal;
